import { z } from 'zod';

export const UserSettingsZod = z.object({
    expert_mode: z.boolean(),
    isEmailMfaEnabled: z.boolean(),
});

export type UserSettings = z.infer<typeof UserSettingsZod>;
